import { render, staticRenderFns } from "./PhotosLayer.vue?vue&type=template&id=25e147bc&scoped=true"
import script from "./PhotosLayer.vue?vue&type=script&lang=js"
export * from "./PhotosLayer.vue?vue&type=script&lang=js"
import style0 from "./PhotosLayer.vue?vue&type=style&index=0&id=25e147bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e147bc",
  null
  
)

export default component.exports